<template>
<div>
   <Loader />
   <div class="join-page" v-show="!orderComplete">
         <div class="container-f2g black-container">
            <div class="f2g-wind-container">

      <!-- First Step Flow ******************************************************************************************************-->
               <div class="join-steps">
                  <div class="large-title">
                     {{content["f2g.simorder.title"]}}
                  </div>
                  <div class="title-overlay2" v-html='content["f2g.simorder.subtitle"]'>
                  </div>
                  <div class="mini-title-blue">
                     {{content["f2g.simorder.step1"]}}
                  </div>
                  <div class="title-overlay4">
                     {{content["f2g.simorder.step1title"]}}
                  </div>
                  <div class="boxes-tele-number">
                     <div class="box-telephone-num" @click="setMode('newnumber')">
                        <div class="title-seemore-services">
                           {{content["f2g.simorder.option1title"]}}
                        </div>
                        <div class="descr-seemore-services">
                           {{content["f2g.simorder.option1subtitle"]}}
                        </div>
                     </div>
                     <div class="box-telephone-num" @click="setMode('portability')">
                        <div class="title-seemore-services">
                           {{content["f2g.simorder.option2title"]}}
                        </div>
                        <div class="descr-seemore-services">
                           {{content["f2g.simorder.option2subtitle"]}}
                        </div>
                     </div>
                  </div>
                 
                  <!-- <div class="container-join" v-else>
                     <span class="text-label-switch"> {{content["f2g.simorder.studenttitle"]}}</span>
                     <label class="container-switch " @change="changeStudentStatus">
                     <input type="checkbox">
                     <span class="slider-for-switch round"></span>
                     </label>
                  </div> -->
                  <!-- <div class="banner-colorful light-blue-banner" v-if="isStudent">
                  <svg class="svg-banner-colorful hidden-sm hidden-xs" width="70px" height="70px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                     <desc>Created with Sketch.</desc>
                     <g id="Icon/sim_type" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <circle id="Oval" cx="16" cy="16" r="12"></circle>
                        <path d="M16.7358542,6.22103125 L27.6212708,12.2313854 C27.8038869,12.3325419 27.9175833,12.5241 27.9175833,12.7326875 C27.9175833,12.941275 27.803896,13.1337292 27.6212708,13.2339896 L24.479,14.9648647 L24.4791667,17.5057708 C24.4791667,17.5477857 24.4746661,17.5887306 24.4661198,17.6281507 C24.4746409,17.6661866 24.4791667,17.7072428 24.4791667,17.749375 C24.4791667,20.8135625 20.8814792,23.30575 16.4583333,23.30575 C14.6413007,23.30575 12.9635704,22.8851748 11.617329,22.1771428 L11.6181684,24.0810905 C12.3005126,24.3189594 12.7916667,24.9687103 12.7916667,25.7317083 L12.7916667,27.2785833 C12.7916667,27.5945812 12.5356417,27.8515 12.21875,27.8515 L9.86979167,27.8515 C9.5529,27.8515 9.296875,27.595475 9.296875,27.2785833 L9.296875,25.7317083 C9.296875,24.9690413 9.788514,24.3186127 10.4713838,24.0808306 L10.4713496,21.4434442 C9.20682741,20.4609895 8.4375,19.1663403 8.4375,17.749375 C8.4375,17.7072428 8.44202573,17.6661866 8.45061853,17.6266649 C8.44200056,17.5887306 8.4375,17.5477857 8.4375,17.5057708 L8.437,14.9648647 L5.2963125,13.2339896 C5.11369417,13.1337292 5,12.941275 5,12.7326875 C5,12.5241 5.11368729,12.3316458 5.2963125,12.2313854 L16.1817292,6.22103125 C16.3545002,6.1261425 16.5630854,6.1261425 16.7358542,6.22103125 Z M11.0442708,25.1301458 C10.7130563,25.1301458 10.4427083,25.3996 10.4427083,25.7317083 L10.4427083,26.7056667 L11.6458333,26.7056667 L11.6458333,25.7317083 C11.6458333,25.4004937 11.3754854,25.1301458 11.0442708,25.1301458 Z M23.333,15.5958647 L16.7340208,19.2317396 C16.6480833,19.279184 16.5531946,19.3033542 16.4583104,19.3033542 C16.3634446,19.3033542 16.2676598,19.279184 16.1817292,19.2317396 L11.617,16.7168647 L11.6167717,20.8776105 C12.8602084,21.6697339 14.5716997,22.1599167 16.4583333,22.1599167 C20.2494375,22.1599167 23.3333333,20.1815667 23.3333333,17.749375 C23.3333333,17.7072428 23.3378591,17.6661866 23.3464519,17.6266649 C23.3378339,17.5887306 23.3333333,17.5477857 23.3333333,17.5057708 L23.333,15.5958647 Z M9.583,15.5958647 L9.58333333,17.5057708 C9.58333333,17.5477857 9.57883278,17.5887306 9.5702865,17.6281507 C9.5788076,17.6661866 9.58333333,17.7072428 9.58333333,17.749375 C9.58333333,18.5356501 9.90588322,19.2746584 10.4705901,19.9147348 L10.471,16.0848647 L9.583,15.5958647 Z M16.4583333,7.37683333 L6.75908333,12.7317708 L10.891,15.0078647 L16.1584229,12.2099812 C16.4377313,12.0613804 16.7841625,12.1679085 16.9336479,12.4472146 C17.0822488,12.7265229 16.9757206,13.0738479 16.6964146,13.2224396 L12.09,15.6688647 L16.4583333,18.0759375 L26.1575833,12.7317708 L16.4583333,7.37683333 Z" id="Combined-Shape" fill="#161B1F" fill-rule="nonzero"></path>
                     </g>
                  </svg>
                  <div>
                     <div class="bold-title-banner">{{content["f2g.simorder.studenttitle"]}}</div>
                     <div class="main-text-banner hidden-sm hidden-xs">{{content["f2g.simorder.studentsubtitle"]}}
                     </div>
                     <div class="main-text-banner">{{content["f2g.simorder.studentmessage"]}}</div>
                  </div>
               </div> -->
               </div>

      <!-- Second Step Flow *** (Final Step in components) *********************************************************************-->
               <NewNumber v-if="mode == 'newnumber'" :content="content" :mode="mode" :simInfo="simInfo" />
               <Portability v-if="mode == 'portability'"
                :content="content" :mode="mode" 
                :prepaidProducts="prepaidProducts" 
                :identificationDocuments="identificationDocuments" 
                @orderComplete="orderComplete=true"/>

            </div>
         </div>
   </div>

   <!-- Success Overlay *********************************************************************--> 
   <div class="container-overlay overlay-form" v-show="orderComplete">
         <div class="overlay-message">
            <img src="/ext_files/prepaid/f2g/images/Success@2x.png" class="logo-overlay" />
               <div class="title-overlay1">
                  {{content["f2g.simorder.success"]}}
               </div>
               <div class="title-overlay4">
                  {{content["f2g.simorder.successcontact"]}}
               </div>
               <div class="overlay-button-container ">                       
                     <div class="container-button transparent-btn button-overlay" @click="orderComplete = false">
                        {{content["f2g.simorder.button1"]}}                      
                     </div> 
                  <a href="/gr/f2g/">
                     <div class="container-button button-overlay blue-btn">
                        {{content["f2g.simorder.button2"]}}
                     </div>
                  </a>  
               </div>      
         </div>             
   </div>
</div>
</template>

<script>

import Loader from './components/Loader'
import Portability from './components/Portability.vue';
import NewNumber from './components/NewNumber.vue';

export default {
   name: 'App',
   data: function() {
      return {
         content: {},
         mode: "",
         selectedSim: {},
         orderComplete: false,
         prepaidProducts: [],
         identificationDocuments: [],
         simInfo: [],
         simProducts: []
      }
   },
   components: {
      Loader,
      Portability,
      NewNumber
   },
   created () {
      /* Hide Footer ************************/
      document.getElementsByClassName("footer-menu-xs")[0].style.display = "none";
      $(".align-footer-f2g").hide();

      /* Get WCS Translations ************************/
      var self = this;
      var locale = document.getElementsByTagName("body")[0].dataset.locale ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";
      
      this.axios.get(`/gr/f2g/vueContentService/?ciKey=simorder&locale=${locale}`).then((response) => {
         self.content = response.data;
         console.log(self.content);
      })
   },
   mounted () {
      /* Get Prepaid Categories ************************/
      var payload = {};

      var caller = {
        "callingSystem":"WINDweb",
        "salesCode":"",
        "username":"username",
        "channel":"F2G"
      }

      caller.locale = document.getElementsByTagName("body")[0].dataset.locale ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";

      payload.caller = caller;

      this.axios.post(`/apiv2/contentrepository/getPrepaidCategories/`, payload).then((response) => {
        if (response.data.errorLevel == 0) {
            for (var j=0; j<response.data.categories.length; j++ ) {
              if (response.data.categories[j].id == 1526319960478) {
                  this.prepaidProducts = response.data.categories[j].PrepaidProducts;
              }
            }
            this.$forceUpdate(); 
        } else {
            console.log("getPrepaidCategories responded with error " + response.data.errorMessage);
        }
      }).then(() => {
        $('.boxes-tele-number').slick({
            infinite: false,
            variableWidth: true,
            arrows: false,
            slidesToShow: 2,
            responsive: [
                  {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                  }
                  },
                  {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  }
                  },
                  {
                  breakpoint: 750,
                  settings: {
                    slidesToShow: 1,
                  }
                  },
                  {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                  }
                  }
              ]
            });
      }).catch((error) => {
        console.log(error);
      });

      /* Get Identification Documents ************************/
      this.axios.post('/apiv2/contentrepository/getIdentificationDocuments/', payload).then((response) => {
      if (response.data.errorLevel == 0) {
        for (var doc=0; doc<response.data.documents.length; doc++) {
          this.identificationDocuments.push(response.data.documents[doc].title);
        }
      } else {
        console.log("getIdentificationDocuments responded with error " + response.data.errorMessage);
      }
      
    }).catch((error) => {
      console.log(error);
    });

    /* Get Sim Cards Information ****************************************************************/
      var payload = {};

      var caller = {
        "callingSystem":"WINDweb",
        "salesCode":"",
        "username":"username",
        "channel":"F2G"
      }

      caller.locale = document.getElementsByTagName("body")[0].dataset.locale ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";

      payload.caller = caller;
      // Change prepaidcustomer to ---->>>> contentrepository
      this.axios.post(`/apiv2/contentrepository/getSimCardsInformation/`, payload).then((response) => {
        if (response.data.errorLevel == 0) {
            this.simInfo = response.data.simInfo;
            for (var j=0; j<response.data.simInfo.length; j++ ) {
               this.simProducts = response.data.simInfo[j].products;
            }
        } else {
            console.log("getSimCardsInformation responded with error " + response.data.errorMessage);
        }
      }).then(() => {

      }).catch((error) => {
        console.log(error);
      });

   },
   computed: {

   },
   updated () {
      this.initDropdowns();
      // this.initInputs();
   },
   methods: {
      // changeStudentStatus() {
      //    this.isStudent = !this.isStudent
      //    if(this.isStudent) {
      //       document.getElementsByClassName("box-telephone-num")[1].classList.add("disabled-join-box");
      //    } else {
      //       document.getElementsByClassName("box-telephone-num")[1].classList.remove("disabled-join-box");
      //    }
      // },
      setMode(mode) { 
         this.mode = mode;
         $(".box-telephone-num").removeClass("active-blue-line");
         if (this.mode == 'newnumber') {
            document.getElementsByClassName("box-telephone-num")[0].classList.add("active-blue-line");
         } else {
            document.getElementsByClassName("box-telephone-num")[1].classList.add("active-blue-line");
         }
         this.$forceUpdate(); 
         if (!$(".all-boxes-card-amount").hasClass("slick-slider")){

         
            $('.all-boxes-card-amount').slick({
               infinite: false,
               variableWidth: true,
               arrows: false,
               slidesToShow: 4,
               responsive: [
                     {
                     breakpoint: 1024,
                     settings: {
                        slidesToShow: 3,
                     }
                     },
                     {
                     breakpoint: 768,
                     settings: {
                        slidesToShow: 2,
                     }
                     },
                     {
                     breakpoint: 600,
                     settings: {
                        slidesToShow: 2,
                     }
                     },
                     {
                     breakpoint: 480,
                     settings: {
                        slidesToShow: 1,
                     }
                     }
                  ]
               });
         }
      },
      handleInputClick(evt){
           $(evt.target).parents('.form-field').addClass('focused');
      },
      handleBlur(evt, value){
           
           if (value == '') {
               $(evt.target).parents('.form-field').removeClass('focused');
           }
      },
      initDropdowns(){
      var self = this;
      var x, i, j, selElmnt, a, b, c;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName("custom-select");
      for (i = 0; i < x.length; i++) {
         if (!x[i].getElementsByTagName("select")[0].classList.contains("select-converted")) {
            selElmnt = x[i].getElementsByTagName("select")[0];
            selElmnt.classList.add("select-converted");
            /*for each element, create a new DIV that will act as the selected item:*/
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            x[i].appendChild(a);
            /*for each element, create a new DIV that will contain the option list:*/
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");
            for (j = 1; j < selElmnt.length; j++) {
               /*for each option in the original select element,
               create a new DIV that will act as an option item:*/
               c = document.createElement("DIV");
               c.innerHTML = selElmnt.options[j].innerHTML;
               c.addEventListener("click", function() {
                  /*when an item is clicked, update the original select box,
                  and the selected item:*/
                  var y, i, k, s, h;
                  s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                  h = this.parentNode.previousSibling;
                  for (i = 0; i < s.length; i++) {
                     if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        for (k = 0; k < y.length; k++) {
                        y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        break;
                     }
                  }
                  h.click();
                  if (c.parentNode.childElementCount > 2) {
                     self.validateDocument();
                  } else {
                     self.validatePortability();
                  }
               });
               b.appendChild(c);
            }
            x[i].appendChild(b);
            a.addEventListener("click", function(e) {
               /*when the select box is clicked, close any other select boxes,
               and open/close the current select box:*/
               e.stopPropagation();
               closeAllSelect(this);
               this.nextSibling.classList.toggle("select-hide");
               this.classList.toggle("select-arrow-active");
            });
         }
    }
    function closeAllSelect(elmnt) {
         /*a function that will close all select boxes in the document,
         except the current select box:*/
         var x, y, i, arrNo = [];
         x = document.getElementsByClassName("select-items");
         y = document.getElementsByClassName("select-selected");
         for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
               arrNo.push(i)
            } else {
               y[i].classList.remove("select-arrow-active");
            }
         }
         for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
               x[i].classList.add("select-hide");
            }
         }
      }
      document.addEventListener("click", closeAllSelect);
    },
  }
}
</script>

<style>

</style>
